import React, { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [mobile, setMobile] = useState(user?.mobile || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try { await api.put(`/users/${user.id}`, { name, mobile }); toast.success("Profile updated"); refresh(); }
    catch { toast.error("Update failed"); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="profile-page">
      <PageHeader title="My Profile" />
      <div className="bg-white border border-border rounded-lg p-6 max-w-lg">
        <div className="flex items-center gap-4 mb-6">
          <div className="h-16 w-16 rounded-full viriks-navy text-amber flex items-center justify-center font-heading text-2xl font-bold">{user?.name?.[0]}</div>
          <div><div className="font-heading font-bold text-navy">{user?.name}</div><div className="text-sm text-muted-foreground capitalize">{user?.role?.replace("_", " ")}</div></div>
        </div>
        <div className="space-y-4">
          <div><Label>Full Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="profile-name" /></div>
          <div><Label>Email</Label><Input value={user?.email} disabled /></div>
          <div><Label>Mobile</Label><Input value={mobile} onChange={(e) => setMobile(e.target.value)} data-testid="profile-mobile" /></div>
          <Button className="viriks-navy text-white" onClick={save} disabled={saving} data-testid="save-profile">{saving ? "Saving..." : "Save Changes"}</Button>
        </div>
      </div>
    </div>
  );
}
